var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"googleMap",staticClass:"google-map",attrs:{"id":"map"}}),(this.google && this.map && this.info)?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map,"info":_vm.info})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }